import {jsx} from 'panel';

import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {DisplayContext} from 'common/widgets/date-range-picker/models/types';
import {TrackingUsageContext} from 'common/report/tracking-setup';

import {DateRangePresetBarEl} from './index';

// Header date selector shim that chooses between rendering the new prototype and the old <mp-query-block>
export function headerDateSelectorRenderer({
  displayContext,
  selectedDateRange,
  projectAsOfDate,
  maxHistoryDays,
  disableDatePickerMessage,
  handleApply,
  handleRemove = null,
}: {
  displayContext: DisplayContext;
  selectedDateRange: null | Partial<DateRange>;
  projectAsOfDate: string;
  maxHistoryDays: number;
  disableDatePickerMessage?: string;
  handleApply: (ev) => void;
  handleRemove?: () => void;
}) {
  return (
    <DateRangePresetBarEl
      attrs={{
        'display-context': displayContext,
        'date-range': JSON.stringify(selectedDateRange ?? null),
        'project-as-of-date': projectAsOfDate,
        'max-history-days': maxHistoryDays,
        'tracked-use-case': TrackingUsageContext.Report,
        'can-clear': !!handleRemove,
        'disable-date-picker-message': disableDatePickerMessage,
        elref: `dateRangePresetBar`,
      }}
      on={{
        apply: handleApply,
        clear: handleRemove,
      }}
    />
  );
}
